<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { ref, inject, onMounted } from 'vue';

const backendApi = inject('backendApi');

const emit = defineEmits(['update', 'update:focused']);
const props = defineProps({
    agencyId: {},
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const loading = ref(true);
const zones = ref([]);
const showRetryButton = ref(false);
const searchQuery = ref('');

const getZones = () => {
    cleanData();

    backendApi()
        .zones({
            agency: props.agencyId,
            pattern: searchQuery.value,
            active: true
        })
        .index()
        .then(success, fail)
        .finally(() => (loading.value = false));

    function success(response) {
        zones.value = response.data;
    }

    function fail() {
        showRetryButton.value = true;
    }
};

const cleanData = () => {
    zones.value = [];
    loading.value = true;
    showRetryButton.value = false;
};

onMounted(() => getZones());
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        :items="zones"
        item-title="name"
        item-value="id"
        :label="hideLabel ? '' : $t('Zones')"
        :loading="loading"
        :show-retry-button="showRetryButton"
        @update="emit('update', selected)"
        @preparing-search="cleanData"
        @search="getZones"
        @retry="getZones"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="`${item.raw.name}`"
                :subtitle="`${
                    item.raw.description ? item.raw.description : ''
                } ~ ${item.raw.zoneType?.type ?? ''}`"
            ></v-list-item>
        </template>
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </AutocompleteFilter>
</template>
